export const DEFAULT_LEAD_STATUS = 'New';
export const DEFAULT_LEAD_TYPE = 'New Lead';

export function isEmptyLeadStatus(status?: string | null): boolean {
  const value = String(status ?? '').trim();
  return (
    !value ||
    value.toLowerCase() === 'n/a' ||
    value.toLowerCase() === 'not assigned' ||
    value.toLowerCase() === 'null'
  );
}

export function isEmptyLeadType(type?: string | null): boolean {
  return isEmptyLeadStatus(type);
}

export function normalizeLeadStatus(status?: string | null): string {
  return isEmptyLeadStatus(status) ? DEFAULT_LEAD_STATUS : String(status).trim();
}

export function normalizeLeadType(type?: string | null): string {
  return isEmptyLeadType(type) ? DEFAULT_LEAD_TYPE : String(type).trim();
}
